import { isArray } from "util";

export default {
    getEmbededResources(target, key) {
        if(target && target['_embedded'] && target['_embedded'][key]) {
            return target['_embedded'][key];
        }
        
        return [];
    },
    getSelfLink(target) {
        if(target && target['_links'] && target['_links'].self && target['_links'].self.href) {
            return target['_links'].self.href;
        }
        return null;
    },
    getLink(target, key, title) {
        if(target && target['_links'] && target['_links'][key]) {
            let links = target['_links'][key];
            
            if(isArray(links)) {
                for(let i in links) {
                    if(links[i].title == title) {
                        return links[i];
                    }
                }
            }
            else if(!title) {
                return target['_links'][key];
            }
            else if (target['_links'][key].title == title) {
                return target['_links'][key];
            }

            return undefined;
        }
        return undefined;
    },
    log(input) {
        // eslint-disable-next-line
        console.log(input);
    }
}